module.exports = __webpack_public_path__ + "img/09.cdb503ed.jpg";